import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'nk-form-errors',
  imports: [TranslateModule],
  templateUrl: './form-errors.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormErrorsComponent<Errors extends ValidationErrors> implements OnChanges {
  @Input() public errors: Errors | null = null;
  @Input() public errorTranslations: Partial<Record<keyof Errors, string>> = {};
  public errorKeys: (keyof Errors)[] | null = null;

  public ngOnChanges(): void {
    if (this.errors) {
      this.errorKeys = Object.keys(this.errors);
    } else {
      this.errorKeys = null;
    }
  }
}
